function NoPage() {
  return (
    <div className="flex-col-container center">
      <div className="flex-row">
        Sorry, this page does not exist!
      </div>
    </div>
  );
}

export default NoPage;